<script>
import DonutChart from "@/components/charts/DonutChart";
export default {
  name: "DisbursementModal",
  components: {
    DonutChart,
  },
  data() {
    return {
      tableData: [],
      tableBusy: false,
      totalRows: 1,
      currentPage: 1,
      perPage: 25,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "type",
      sortDesc: false,
      fields: [
        {
          key: "item",
          sortable: false,
          label: "",
          thStyle: { width: "50px" },
        },
        {
          key: "disbursementNumber",
          sortable: true,
          label: "DV Number",
        },
        {
          key: "details",
          sortable: true,
        },
        {
          key: "modeOfPayment",
          sortable: true,
        },
        {
          key: "amountCurrency",
          sortable: true,
        },
      ],
      chartData: [],
    };
  },
  computed: {
    rows() {
      return this.tableData.length;
    },
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getData(row) {
      this.chartData = [row.allocated, row.totalDisbursement];
      this.tableBusy = true;
      this.$store
        .dispatch("fundsource/GetFundSourceDisbursements", {
          id: row.id,
          cycle: this.$store.state.data.cycle,
        })
        .then((res) => {
          res.data.forEach((item) => {
            item.amountCurrency = this.formatCurrency(item.amount);
            item.rotateChevy = false;
          });
          this.tableBusy = false;
          this.tableData = res.data;
        })
        .catch(() => {
          this.tableBusy = false;
          this.showToast("Something  went wrong!", "error");
        });
    },
    showDtls(row) {
      row.item.rotateChevy = !row.item.rotateChevy;
      row.toggleDetails();
    },
  },
};
</script>
<template>
  <b-modal
    id="fs-disbursement-modal"
    title="Disbursement List"
    size="lg"
    title-class="font-18"
    hide-footer
    no-close-on-backdrop
  >
    <DonutChart
      :height="30"
      :width="100"
      :data="chartData"
      :labels="['Allocation', 'Disbursements']"
    />
    <div class="table-responsive mb-0 mt-3">
      <b-table
        class="datatables"
        :items="tableData"
        :fields="fields"
        responsive="sm"
        :per-page="perPage"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :filter="filter"
        :filter-included-fields="filterOn"
        :busy="tableBusy"
        @filtered="onFiltered"
        bordered
        outlined
        hover
        striped
        show-empty
      >
        <template #empty="scope">
          <div class="text-center">{{ scope.emptyText }}</div>
        </template>
        <template #table-busy>
          <div class="d-flex justify-content-center align-items-center">
            <div class="preloader-component me-2">
              <div class="status">
                <div class="spinner-chase w-20px h-20px">
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                </div>
              </div>
            </div>
            <strong>Loading...</strong>
          </div>
        </template>
        <template #cell(item)="row">
          <div
            class="d-flex align-items-center justify-content-center"
            @click="showDtls(row)"
          >
            <i
              class="bx bx-chevron-right rotate font-size-16 cursor-pointer"
              :class="{
                'rotate-90': row.item.rotateChevy,
              }"
            ></i>
          </div>
        </template>
        <template #cell(details)="row">
          <div>
            <span class="text-white">{{ row.item.payee }}</span>
          </div>
          <div>
            <small>{{ row.item.particulars }}</small>
          </div>
        </template>
        <template #row-details="row">
          <div class="card">
            <div class="card-header d-flex align-items-center justify-content-between">
              <h5 class="card-title mb-0">More Details</h5>
              <div>
                <a href="javascript:void(0)" @click="showDtls(row)"
                  ><i class="bx bx-x text-white font-size-24"></i
                ></a>
              </div>
            </div>
            <div class="card-body">
              <div class="d-flex align-items-center">
                <i class="bx bx-list-ol"></i>
                BURS Number: <span class="text-info ms-1">{{ row.item.bursNumber }}</span>
              </div>
              <div class="d-flex align-items-center">
                <i class="bx bx-calendar"></i>
                Disbursement Date:
                <span class="text-info ms-1">{{
                  formatDate(new Date(row.item.disbursementDate))
                }}</span>
              </div>
              <div class="d-flex align-items-center">
                <i class="bx bx-calendar"></i>
                Check Date:
                <span class="text-info ms-1">{{
                  formatDate(new Date(row.item.checkDate))
                }}</span>
              </div>
            </div>
          </div>
        </template>
      </b-table>
    </div>
    <div class="row">
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-end">
          <ul class="pagination pagination-rounded mb-0">
            <!-- pagination -->
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>
  </b-modal>
</template>
